import React, { useEffect, useState } from "react";
import { Modal, Form, Container, Col, Row, Badge } from "react-bootstrap";
import {
  useAssignJobMutation,
  useDeleteJobMutation,
  useGetAllUsersQuery,
} from "../../store";
import {
  CustomTable,
  DeleteButton,
  LoadingBox,
  MessageBox,
  MotionDiv,
  useTitle,
  ViewButton,
} from "../../components";
import { useGetAllJobsQuery } from "../../store";
import { redirect, useNavigate } from "react-router-dom";
import { ImCross } from "react-icons/im";
import { FaCheck, FaUserPlus, FaUserTimes } from "react-icons/fa";
import { Button } from "react-bootstrap";
import { ChatButton } from "../../components/layout/CustomTable";
import {
  ConfirmationModal,
  DateInput,
  SelectInput,
} from "../../components/layout/CustomForm";
import { toast, ToastContainer } from "react-toastify";
import { toastOptions } from "../../utils/error";
import { useGetAllpropertyQuery } from "../../store/api/property_preference";

import { FaEdit } from "react-icons/fa";
import axiosInstance from "../../utils/axiosUtil";
import { current } from "@reduxjs/toolkit";
// import AssignJobModal from "./AssignJobModal"; // Import the new AssignJobModal component

const column = [
  "Sr No.",
  
   "Intended Use",
  "Created At",
  "Updated At",

  "Actions",
];

const AppraiserPurpose = () => {
  useTitle("Property Management");

  const [currentPage, setCurrentPage] = useState(1);
  const [resultPerPage, setResultPerPage] = useState(10);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [app_purpose,setApp_purpose] = useState('')
  const [jobId, setJobId] = useState("");
  const [job, setJob] = useState(null);
  const [jobs, setJobs] = useState([]);
  const navigate = useNavigate();
  const [editId, setEditId] = useState("");
  const [filters, setFilters] = useState({
    job_status: "", // For example: "Assigned", "Not Assigned"
    from: "",
    to: "",
  });

  const { isLoading, isFetching, isError, data, error, refetch, success } =
    useGetAllpropertyQuery({
      page: currentPage,
      limit: resultPerPage,
      ...filters,
    });

  const [
    deleteJob,
    {
      isLoading: isDeleteLoading,
      isSuccess: isDeleteSuccess,
      isError: isDeleteError,
    },
  ] = useDeleteJobMutation();

  //    get all property types
  async function fetchData() {
    const { data } = await axiosInstance.get(`/intended_use?page=${currentPage}&limit=${resultPerPage}`);
    setJobs(data);
  }
  //   get single data
  async function getSingleData(id) {
    try {
      const { data } = await axiosInstance.get(
        `/admin/property_type/single/${id}`
      );
      setPropertyType(data?.property?.property_type)
      setEditCost(data?.property?.cost_of_property)
      
    } catch (error) {
      toast.error("Not found ", toastOptions);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);
  const [propertyType, setPropertyType] = useState('');
  const [editCost,setEditCost] = useState('')
  const [propertyType1, setPropertyType1] = useState('');
  const [costOfProperty,setCostOfProperty] = useState()
  const [showModal, setShowModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleShow1 = () => setShowModal1(true);

  const handleClose = () => setShowModal(false);
  const handleClose1 = () => setShowModal1(false);
  const handleSave = async () => {
    try {
      const { data } = await axiosInstance.put(
        `/admin/property_type/update/${editId}`, {property_type: propertyType}
      );
      fetchData()
      handleClose(); // Close the modal after saving
      toast.success("Property type updated successfully", toastOptions);
     
    } catch (error) {
      toast.error(error?.data?.message, toastOptions);

      handleClose(); // Close the modal after saving
    }
  };

//    add property type 
const createProperty = async () => {
    try {
      const { data } = await axiosInstance.post(
        `/intended_use`, {intended_use:app_purpose}
      );
      fetchData()
      handleClose1(); // Close the modal after saving
      toast.success("Property type added successfully", toastOptions);
       setApp_purpose('')
    } catch (error) {
      toast.error(error?.data?.message, toastOptions);
      setApp_purpose('')

      handleClose1(); // Close the modal after saving
    }
  };
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
    setCurrentPage(1);
  };

  const clearFilters = () => {
    setFilters((prev) => ({
      job_status: "", // For example: "Assigned", "Not Assigned"
      from: "",
      to: "",
    }));
  };

  console.log("Data: ", data);

  const pageHandler = (p) => {
    setCurrentPage(p);
  };

  const handleAssignJob = (job) => {
    setJob(job);
    setShowAssignModal(true);
  };

  const handleDelete = async (id) => {
    try {
        if (window.confirm(`Are you sure want to delete property ?`) == true) {
            const { data } = await axiosInstance.delete(
                `/admin/delete_app_purpose/${id}`
              );
              toast.success("Property type deleted  successfully", toastOptions);
              fetchData();
        }
     
    } catch (error) {
      toast.error("Something went wrong!", toastOptions);
    }
  };

  const handleEdit = async (id) => {
    try {
      const { data } = await axiosInstance.put(
        `/admin/property_type/update/${id}`, {property_type: propertyType}
      );
      toast.success("property type updated successfully", toastOptions);
      fetchData();
    } catch (error) {
      toast.error("something went wrong!", toastOptions);
    }
  };

  const handleOnHide = () => {
    setShowConfirmationModal(false);
  };

  const deleteHandler = async (e) => {
    e.preventDefault();
    await deleteJob(jobId);
  };

  useEffect(() => {
    if (isDeleteSuccess) {
      refetch();
    }
  }, [isDeleteSuccess]);
   useEffect(()=>{
    fetchData()
   },[resultPerPage,currentPage])

  return (
    <>
      <MotionDiv>
        {isError ? (
          <MessageBox variant="danger">
            {error?.data?.error?.message}
          </MessageBox>
        ) : (
          <>
            <div>
              <Button className="mb-2" onClick={()=> setShowModal1(true)}>Add Intended Use</Button>
            </div>

            <CustomTable
              loading={isFetching}
              column={column}
              rowNo={resultPerPage}
              rowProps={{ setResultPerPage }}
              paging={true}
              pageProps={{
                numOfPages: jobs.totalPages,
                curPage: currentPage,
              }}
              pageHandler={pageHandler}
            >
              {jobs.totalPurposes > 0 ? (
                jobs.purposes.map((job, i) => (
                  <tr key={job?.id} className="odd">
                    <td className="text-center">
                      {(currentPage - 1) * resultPerPage + i + 1}
                    </td>
                    <td style={{ textTransform: "capitalize" }}>
                      {job?.intended_use}
                    </td>
                    

                    <td style={{ textTransform: "capitalize" }}>
                      {job?.created_at}
                    </td>
                    <td>{job.updated_at}</td>
                    <td className="text-center">
                      {/* <Button
                        className="mx-1"
                        onClick={() => {
                          setShowModal(true);
                          setEditId(job.id);
                          getSingleData(job.id);
                        }}
                      >
                        <FaEdit />
                      </Button> */}
                      <DeleteButton onClick={() => handleDelete(job.id)} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={12} className="text-center">
                    No Data Found!
                  </td>
                </tr>
              )}
              {/* Delete Job */}
              <ConfirmationModal
                show={showConfirmationModal}
                onHide={handleOnHide}
                title="Delete Job"
                body="Do you really want to delete this Job ?"
                successMessage="Job Deleted Successfully!"
                submitHandler={deleteHandler}
                reducerProps={{
                  loading: isDeleteLoading,
                  success: isDeleteSuccess,
                  error: isDeleteError,
                }}
              ></ConfirmationModal>

              {/* Assign job modal */}
            </CustomTable>
          </>
        )}
      </MotionDiv>
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Property Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Property Type</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter property type"
                name="property_type"
                value={propertyType}
                onChange={(e) => setPropertyType(e.target.value)}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Property Type</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter cost of property"
                name="property_type"
                value={editCost}
                onChange={(e) => setEditCost(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      {/* second model for  add  property type  */}
      <Modal show={showModal1} onHide={handleClose1}>
        <Modal.Header closeButton>
          <Modal.Title>Add Intended Use</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Intended Use</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter intended use"
                name="property_type"
                value={app_purpose}
                onChange={(e) => setApp_purpose(e.target.value)}
              />
            </Form.Group>
           
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose1}>
            Close
          </Button>
          <Button variant="primary" onClick={createProperty}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer />
    </>
  );
};

export default AppraiserPurpose;
